export default "__VITE_ASSET__B_GEi0FD__"